import { ErrorBoundary } from 'react-error-boundary';
import { MemoryRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { trackError } from 'utils/helpers';
import { connectedComponent } from 'utils/redux/providerWrapper';
import ExpiryBookingCheck from 'components/expiry_booking_check';
import { bookingFormFallbackRender } from '../error_boundary';
import Experience from './experience';

const ExperienceRouter = ({ noExpiryCheck }) => (
  <MemoryRouter>
    <ErrorBoundary
      fallbackRender={bookingFormFallbackRender}
      onError={trackError}
    >
      <Experience />
    </ErrorBoundary>
    {!noExpiryCheck && <ExpiryBookingCheck reload />}
  </MemoryRouter>
);

ExperienceRouter.propTypes = {
  noExpiryCheck: PropTypes.bool,
};

export const ConnectedExperience = connectedComponent(ExperienceRouter);
